/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { SAMPLE_TO_SALE_SCREEN } from '../../global/Constants';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import Loader from './loader/Loader';

class GpsCoordinates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            latitude: null,
            longitude: null,
            address: "Unknown Location",
            isLoading: false
        }
        this.getMyLocation = this.getMyLocation.bind(this)
    }

    componentDidMount() {
        this.getMyLocation();
    }

    getAddressFromLatLong(latLng) {
        if (Utilities.isNetworkConnected()) {
            var body = JSON.stringify({
                latitude: latLng.latitude,
                longitude: latLng.longitude
            });

            try {
                ApiServices.getAddressFromLatLong(body).then(response => {
                    this.setState({ isLoading: false });
                    var status = response.success;

                    if (status) {
                        this.setState({ address: response.data.address });
                        Utilities.LogPrint("getAddressFromLatLongSuccess", response);
                    } else {
                        Utilities.LogPrint("getAddressFromLatLong", response);
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                    Utilities.LogPrint("getAddressFromLatLong", error);
                });
            } catch (error) {
                this.setState({ isLoading: false });
                Utilities.LogPrint("getAddressFromLatLong", error);
            }
        }
    }

    onRefreshClick = () => {
        this.getMyLocation();
    }

    getMyLocation() {
        const location = window.navigator && window.navigator.geolocation;
        if (location) {
            location.getCurrentPosition((position) => {
                this.setState({ latitude: position.coords.latitude.toFixed(6), longitude: position.coords.longitude.toFixed(6) })
                let latLng = {
                    latitude: position.coords.latitude.toFixed(6),
                    longitude: position.coords.longitude.toFixed(6)
                }
                this.getAddressFromLatLong(latLng);
                Utilities.LogPrint("getMyLocationLatlong", latLng);
                this.props.getCoordinates(latLng);
            }, (error) => {
                this.setState({ latitude: 'null', longitude: 'null' })
                console.error("Error Code = " + error.code + " - " + error.message);
            })
        }
    }

    getDistance(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit === "K") { dist = dist * 1.609344 }
        if (unit === "M") { dist = dist * 0.8684 }
        return dist
    }

    render() {
        const { isLoading, latitude, longitude, address } = this.state;
        let latlong = latitude + ", " + longitude

        return (
            <div className="row" >
                <div className="col-lg-12">
                    <div className="form-group">
                        <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.GPS_COORDINATES}</label>
                        <div className="d-flex align-items-center">
                            <input type="text" className="form-control max-w-360" placeholder="" value={latlong} readOnly />
                            <i className="customic ic-click-photo ic-refresh2" onClick={this.onRefreshClick}></i>
                            {/* <a class="ml-2 mt-2"></a> */}
                        </div>
                        <span className="error-msg d-none"><i className="customic ic-error"></i> Switch on the GPS on your phone to get Co-ordinates</span>
                        <span className="mt-2 d-block gray-text">{address}</span>
                    </div>
                </div>
                {isLoading ? <Loader /> : null}
            </div>
        )
    }
}

export default GpsCoordinates;